module.exports = __webpack_public_path__ + "img/comic-oil-painting.f58ac53c.jpg";